export default __webpack_public_path__ + "b4f06c6acf687a431b78138da30d0265.webp";